/**
 * Normalizes Arabic text by removing tashkeel (diacritics) and normalizing Alif, Yaa, and Taa Marbouta.
 * @param {string} text - The input text to normalize.
 * @returns {string} The normalized text.
 */
export const normalizeArabicText = (text) => {
    if (!text) return "";
    return text
        .replace(/[\u064B-\u065F\u0670]/g, "") // Remove diacritics (Fatha, Damma, Kasra, Shadda, Sukoon, etc.)
        .replace(/[أإآ]/g, "ا") // Normalize Alif variants to plain Alif
        .replace(/ة/g, "ه") // Normalize Taa Marbouta to Haa
        .replace(/ى/g, "ي"); // Normalize Alif Layyinah to Yaa
};

/**
 * Strips HTML tags from a string.
 * @param {string} html - The input HTML string.
 * @returns {string} The plain text.
 */
export const stripHtml = (html) => {
    if (!html) return "";
    return html.replace(/<[^>]*>/g, "");
};
